import { css, jsx } from '@emotion/react';
import { useSecondaryNavContext } from './SecondaryNavContext.es.js';
import { useSecondaryNavItemContext } from './SecondaryNavItemContext.es.js';

const styles = {
  navList: css({
    "& ul": {
      marginTop: "var(--zds-space-4, 0.25rem)"
    }
  })
};
const SecondaryNavList = ({ children, className }) => {
  const navItemContext = useSecondaryNavItemContext();
  const { expandedSectionKeys } = useSecondaryNavContext();
  const isTopLevelList = !navItemContext;
  const isHidden = isTopLevelList ? void 0 : !expandedSectionKeys.includes(navItemContext.itemId);
  return jsx("ul", { className, css: styles.navList, "data-zds": true, hidden: isHidden, id: navItemContext === null || navItemContext === void 0 ? void 0 : navItemContext.listId }, children);
};

export { SecondaryNavList };
//# sourceMappingURL=SecondaryNavList.es.js.map
